<div class="row m-0" *ngIf="TotalPagesArray.length > 0">
  <div class="col-md-7 col-sm-12 p-0 mb-md-0 mb-2">
    <nav>
      <ul class="pagination justify-content-md-start justify-content-center align-items-center m-0">
        <li class="page-item" [ngClass]="{'disabled':PageNumber <= 1}" (click)="NextPreviousResultPage(false)">
          <button class="page-link">Previous</button>
        </li>
        <li class="page-item" *ngFor="let page of TotalPagesArray" [ngClass]="{'active':PageNumber == page}"
          (click)="OnChangePageNumber(page)">
          <button class="page-link non-active">{{page}}</button>
        </li>
        <li class="page-item" [ngClass]="{'disabled':PageNumber >= TotalPages}" (click)="NextPreviousResultPage(true)">
          <button class="page-link">Next</button>
        </li>
      </ul>
    </nav>
  </div>
  <div class="col-md-5 col-sm-7 m-auto p-0 pl-1">
    <div class="d-flex justify-content-md-end justify-content-center align-items-center">
      <div class="col-7 p-0 pr-1 text-md-right">
        Results Per Page:
      </div>
      <div class="col-4 p-0">
        <select id="ResultsPerPage" name="ResultsPerPage" [(ngModel)]="PageSize" (change)="OnPageSizeChange()" class="form-control" aria-label="Results Per Page">
          <option [value]="15">15</option>
          <option [value]="25">25</option>
          <option [value]="50">50</option>        
        </select>
      </div>
    </div>
  </div>
</div>